import {
  BOUNCE_IN_BOTTOM,
  BOUNCE_IN_LEFT,
  BOUNCE_IN_RIGHT,
  BOUNCE_IN_TOP,
  FADE_IN,
  FADE_OUT,
  SLIDE_IN_FROM_BOTTOM,
  SLIDE_IN_FROM_LEFT,
  SLIDE_IN_FROM_RIGHT,
  SLIDE_IN_FROM_TOP,
  SLIDE_OUT_TO_BOTTOM,
  SLIDE_OUT_TO_LEFT,
  SLIDE_OUT_TO_RIGHT,
  SLIDE_OUT_TO_TOP,
  ZOOM_IN,
  ZOOM_OUT
} from './keyframes';
import type {
  SlideInAnimationValue,
  SlideInCustomAnimationDirection
} from './types';

export function getSlideAnimations(
  direction: SlideInCustomAnimationDirection,
  isVisible: boolean
) {
  const animationMap = {
    left: isVisible ? SLIDE_IN_FROM_LEFT : SLIDE_OUT_TO_LEFT,
    right: isVisible ? SLIDE_IN_FROM_RIGHT : SLIDE_OUT_TO_RIGHT,
    top: isVisible ? SLIDE_IN_FROM_TOP : SLIDE_OUT_TO_TOP,
    bottom: isVisible ? SLIDE_IN_FROM_BOTTOM : SLIDE_OUT_TO_BOTTOM,
    center: isVisible ? FADE_IN : FADE_OUT
  };

  return animationMap[direction];
}

export function getFadeAnimations(isVisible: boolean) {
  return isVisible ? FADE_IN : FADE_OUT;
}

export function getBounceAnimations(
  direction: SlideInCustomAnimationDirection,
  isVisible: boolean
) {
  if (isVisible) {
    const bounceInMap = {
      left: BOUNCE_IN_LEFT,
      right: BOUNCE_IN_RIGHT,
      top: BOUNCE_IN_TOP,
      bottom: BOUNCE_IN_BOTTOM
    };

    return bounceInMap[direction];
  }

  // For exit, use regular slide out
  return getSlideAnimations(direction, false);
}

export function getZoomAnimations(isVisible: boolean) {
  return isVisible ? ZOOM_IN : ZOOM_OUT;
}

export function getAnimationForType(
  animationType: SlideInAnimationValue,
  direction: SlideInCustomAnimationDirection,
  isVisible: boolean
) {
  switch (animationType) {
    case 'slide':
      return getSlideAnimations(direction, isVisible);
    case 'fade':
      return getFadeAnimations(isVisible);
    case 'bounce':
      return getBounceAnimations(direction, isVisible);
    case 'zoom':
      return getZoomAnimations(isVisible);
    case 'instant':
    default:
      return null;
  }
}

export function getTransformOrigin(
  direction: SlideInCustomAnimationDirection
): string {
  const originMap = {
    left: 'left center',
    right: 'right center',
    top: 'center top',
    bottom: 'center bottom'
  };

  return originMap[direction];
}
